'use client';

import { useMemo } from 'react';
import { can, hasRoleAtLeast, type Permission } from '@slims/shared/auth';
import type { UserRole } from '@/lib/utils/tenant';
import { useAuthStore } from '@/stores/auth-store';

export function usePermission(perm: Permission): boolean {
	const role = useAuthStore((s) => s.role);
	return useMemo(() => (role ? can(role, perm) : false), [role, perm]);
}

export function useHasRole(minimum: UserRole): boolean {
	const role = useAuthStore((s) => s.role);
	return useMemo(() => (role ? hasRoleAtLeast(role, minimum) : false), [role, minimum]);
}
